"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddonCDNHostType = exports.DialogOrientation = exports.IReqType = exports.AddonEnvironmentType = exports.DocElementType = exports.AddonResourcesHostType = exports.DocsOriginType = exports.ResizeMode = exports.ActionName = exports.ToolbarButtonType = exports.MenuType = exports.ImageSourceType = exports.OCRType = void 0;
var OCRType;
(function (OCRType) {
    OCRType[OCRType["LATEX"] = 1] = "LATEX";
})(OCRType = exports.OCRType || (exports.OCRType = {}));
var ImageSourceType;
(function (ImageSourceType) {
    ImageSourceType["PIC"] = "pic";
    ImageSourceType["LATEX"] = "latex";
    ImageSourceType["SIGN"] = "sign";
    ImageSourceType["SIGNBAR"] = "signbar";
})(ImageSourceType = exports.ImageSourceType || (exports.ImageSourceType = {}));
var MenuType;
(function (MenuType) {
    MenuType["NORMAL"] = "normal";
    MenuType["DIVIDE"] = "divide";
})(MenuType = exports.MenuType || (exports.MenuType = {}));
var ToolbarButtonType;
(function (ToolbarButtonType) {
    ToolbarButtonType["FULLSCREEN"] = "fullscreen";
    ToolbarButtonType["CUSTOM"] = "custom";
    ToolbarButtonType["DOWNLOAD"] = "download";
})(ToolbarButtonType = exports.ToolbarButtonType || (exports.ToolbarButtonType = {}));
var ActionName;
(function (ActionName) {
    ActionName["DIALOG"] = "openDialog";
    ActionName["SIDEBAR"] = "openSidebar";
    ActionName["PAGE"] = "openPage";
    ActionName["URL"] = "openURL";
})(ActionName = exports.ActionName || (exports.ActionName = {}));
var ResizeMode;
(function (ResizeMode) {
    ResizeMode[ResizeMode["NONE"] = 0] = "NONE";
    ResizeMode[ResizeMode["VERTICAL"] = 1] = "VERTICAL";
})(ResizeMode = exports.ResizeMode || (exports.ResizeMode = {}));
var DocsOriginType;
(function (DocsOriginType) {
    DocsOriginType["DEFAULT"] = "https://docs.qq.com";
    DocsOriginType["ENTERPRISE_WECOM"] = "https://doc.weixin.qq.com";
})(DocsOriginType = exports.DocsOriginType || (exports.DocsOriginType = {}));
var AddonResourcesHostType;
(function (AddonResourcesHostType) {
    AddonResourcesHostType["DEFAULT"] = "cdn.addon.tencentsuite.com";
    AddonResourcesHostType["ENTERPRISE_WECOM"] = "wecom-addon.tencentsuite.com";
})(AddonResourcesHostType = exports.AddonResourcesHostType || (exports.AddonResourcesHostType = {}));
var DocElementType;
(function (DocElementType) {
    DocElementType["TEXT"] = "text";
    DocElementType["IMAGE"] = "image";
    DocElementType["IFRAME"] = "iframe";
    DocElementType["LINK"] = "link";
    DocElementType["HINA"] = "hina";
})(DocElementType = exports.DocElementType || (exports.DocElementType = {}));
var AddonEnvironmentType;
(function (AddonEnvironmentType) {
    AddonEnvironmentType["PRODUCTION"] = "prod";
    AddonEnvironmentType["PREVIEW"] = "pre";
    AddonEnvironmentType["AUDIT"] = "audit";
    AddonEnvironmentType["DEVELOPMENT"] = "dev";
})(AddonEnvironmentType = exports.AddonEnvironmentType || (exports.AddonEnvironmentType = {}));
var IReqType;
(function (IReqType) {
    IReqType["LIST"] = "getAddonList";
    IReqType["INVOKE"] = "invoke";
})(IReqType = exports.IReqType || (exports.IReqType = {}));
var DialogOrientation;
(function (DialogOrientation) {
    DialogOrientation[DialogOrientation["PORTRAIT"] = 1] = "PORTRAIT";
    DialogOrientation[DialogOrientation["LANDSCAPE"] = 2] = "LANDSCAPE";
})(DialogOrientation = exports.DialogOrientation || (exports.DialogOrientation = {}));
var AddonCDNHostType;
(function (AddonCDNHostType) {
    AddonCDNHostType["DEFAULT"] = "docs.gtimg.com";
    AddonCDNHostType["ENTERPRISE"] = "wecom-addon.tencentsuite.com";
})(AddonCDNHostType = exports.AddonCDNHostType || (exports.AddonCDNHostType = {}));
//# sourceMappingURL=enum.js.map